<template>
  <div :id="pFileListPreviewsClass" class="row">
    <div class="col-xs-12">
      <span v-if="noneVisible" class="emptyOrNull">{{ 'dictionary.general.none' | i18nText(pDictionary) }}</span>
      <file-preview
          v-for="file in files" :p-file="file" :key="file.id"
          :p-currencies="pCurrencies"
          :p-language="pLanguage"
          :p-dictionary="pDictionary"
          :p-urls="pUrls">
      </file-preview>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import FilePreview from "@/components/modules/file-module/file/preview/FilePreview";

export default {
  name: "FilePreviewList",
  components: {FilePreview},
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pFiles: {
      type: Array,
      required: true
    },
    pFileListPreviewsClass: {
      type: String,
      default: function () {
        return 'formFileListPreviews';
      }
    },
    pFileHideEmptyList: {
      type: Boolean,
      default: function () {
        return false;
      }
    }
  },
  data: function () {
    return {
      files: this.pFiles
    }
  },
  computed: {
    noneVisible: function () {
      return !this.pFileHideEmptyList
             && this.files.length === 0;
    }
  }
}
</script>

<style scoped>

</style>